import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { SET_ALL, DISABLE, UPDATE } from '@/store/actions/tutorial';

export const initialState = {
    create: {
        search: true,
        map: true,
        mobileCTA: true
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE: {
            const { field, value } = action.data;

            return {
                ...state,
                [field]: value
            };
        }

        case SET_ALL: {
            const { key } = action.data;

            return {
                ...state,
                [action.data]: Object.keys(state[key]).reduce(
                    (memo, stateKey) => {
                        memo[stateKey] = true;
                        return memo;
                    },
                    {}
                )
            };
        }

        case DISABLE: {
            const { type, key } = action.data;

            return {
                ...state,
                [type]: {
                    ...state[type],
                    [key]: false
                }
            };
        }

        case AUTH_INVALIDATE:
        default:
            return state;
    }
};
